import React, { useRef, useEffect, useState } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { irBlack } from "react-syntax-highlighter/dist/esm/styles/hljs";
import ReactMarkdown, { MarkdownHooks } from 'react-markdown';
import remarkGfm from "remark-gfm";
import remarkGemoji from 'remark-gemoji';

import PropTypes from 'prop-types';
import mermaid from 'mermaid'; // adjust the import path as needed

mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
});


const CodeBlock = ({ language, value }) => (
  <div className="code-frame">
    <SyntaxHighlighter language={language} style={irBlack} wrapLongLines>
      {value}
    </SyntaxHighlighter>
  </div>
);

function TheoryBlock({ description }) {
  return (
    <section className="theory-section">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkGemoji]}
        components={{
          code({ inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || '');
            if (!inline && match) {
              const lang = match[1];
              const content = String(children).replace(/\n$/, '');
              if (lang === 'mermaid') {
                return <mermaid chart={content} />;
              }
              return <CodeBlock language={lang} value={content} />;
            }
            return <code className={className} {...props}>{children}</code>;
          }
        }}
      >
        {description}
      </ReactMarkdown>
    </section>
  );
}

TheoryBlock.propTypes = {
  description: PropTypes.string.isRequired,
};

export default TheoryBlock;
